// utiliza o Bluebird como engine de promises
import Bluebird from 'bluebird';

global.Promise = Bluebird;
Bluebird.config({
  warnings: (process.env['NODE_ENV'] !== 'production') && { wForgottenReturn: false },
  longStackTraces: process.env['NODE_ENV'] !== 'production',
  cancellation: true
});